export enum Types {
	SET_LOADER = '@app/SET_LOADER',
}

export interface LoaderState {
	visible: boolean;
}
